import api from "./api";

const autorizacoesService = {
  // --- Checklist de Autorização (uso analista) ---
  criarChecklistAutorizacao: async (payload) => {
    try {
      const response = await api.post("ChecklistAutorizacao", payload);
      return response.data;
    } catch (error) {
      throw (
        error.response?.data || {
          message: "Erro ao criar checklist de autorização",
        }
      );
    }
  },

  listarChecklistsAutorizacaoPaginado: async ({
    nome,
    pageNumber = 1,
    pageSize = 10,
  } = {}) => {
    try {
      const params = Object.fromEntries(
        Object.entries({ nome, pageNumber, pageSize }).filter(
          ([_, v]) => v !== "" && v != null
        )
      );
      const response = await api.get("ChecklistAutorizacao", { params });
      const items = response.data?.data || [];
      return {
        items,
        totalCount: response.data?.total ?? items.length,
        pageNumber: response.data?.pageNumber ?? pageNumber,
        pageSize: response.data?.pageSize ?? pageSize,
        totalPages:
          response.data?.totalPages ??
          Math.ceil((response.data?.total ?? items.length) / pageSize),
      };
    } catch (error) {
      throw (
        error.response?.data || { message: "Erro ao listar checklists" }
      );
    }
  },

  getChecklistPorTipo: async (tipo) => {
    try {
      const response = await api.get(`ChecklistAutorizacao/tipo/${tipo}`);
      return response.data;
    } catch (error) {
      if (error.response?.status === 404) return null;
      throw (
        error.response?.data || { message: "Erro ao buscar checklist" }
      );
    }
  },

  atualizarChecklistAutorizacao: async (payload) => {
    try {
      const response = await api.put("ChecklistAutorizacao", payload);
      return response.data;
    } catch (error) {
      throw (
        error.response?.data || {
          message: "Erro ao atualizar checklist de autorização",
        }
      );
    }
  },

  deletarChecklistAutorizacao: async (id) => {
    try {
      const response = await api.delete(`ChecklistAutorizacao/${id}`);
      return response.data;
    } catch (error) {
      throw (
        error.response?.data || {
          message: "Erro ao excluir checklist de autorização",
        }
      );
    }
  },

  // --- Solicitação de Autorização (uso interessado) ---
  criarSolicitacao: async (payload) => {
    try {
      const response = await api.post("SolicitacaoDeAutorizacao", payload);
      return response.data;
    } catch (error) {
      throw (
        error.response?.data || {
          message: "Erro ao criar solicitação de autorização",
        }
      );
    }
  },

  listarMinhasSolicitacoes: async ({ pageNumber = 1, pageSize = 10 } = {}) => {
    try {
      const response = await api.get("SolicitacaoDeAutorizacao/Usuario/Minhas", {
        params: { pageNumber, pageSize },
      });
      const items = response.data?.data || [];
      return {
        items,
        totalCount: response.data?.total ?? items.length,
        pageNumber: response.data?.pageNumber ?? pageNumber,
        pageSize: response.data?.pageSize ?? pageSize,
        totalPages:
          response.data?.totalPages ??
          Math.ceil((response.data?.total ?? items.length) / pageSize),
      };
    } catch (error) {
      throw (
        error.response?.data || { message: "Erro ao listar autorizações" }
      );
    }
  },

  getById: async (id) => {
    try {
      const response = await api.get(`SolicitacaoDeAutorizacao/${id}`);
      return response.data;
    } catch (error) {
      throw (
        error.response?.data || { message: "Erro ao obter autorização" }
      );
    }
  },

  listarTodasSecretario: async ({ pageNumber = 1, pageSize = 10 } = {}) => {
    try {
      const response = await api.get("SolicitacaoDeAutorizacao/Secretario/Todas", {
        params: { pageNumber, pageSize },
      });
      const items = response.data?.data || [];
      return {
        items,
        totalCount: response.data?.total ?? items.length,
        pageNumber: response.data?.pageNumber ?? pageNumber,
        pageSize: response.data?.pageSize ?? pageSize,
        totalPages:
          response.data?.totalPages ??
          Math.ceil((response.data?.total ?? items.length) / pageSize),
      };
    } catch (error) {
      throw (
        error.response?.data || { message: "Erro ao listar autorizações" }
      );
    }
  },

  // --- Uso do analista ---
  listarTodasAnalista: async ({ pageNumber = 1, pageSize = 10 } = {}) => {
    try {
      const response = await api.get("SolicitacaoDeAutorizacao/Analista/Todas", {
        params: { pageNumber, pageSize },
      });
      const items = response.data?.data || [];
      return {
        items,
        totalCount: response.data?.total ?? items.length,
        pageNumber: response.data?.pageNumber ?? pageNumber,
        pageSize: response.data?.pageSize ?? pageSize,
        totalPages:
          response.data?.totalPages ??
          Math.ceil((response.data?.total ?? items.length) / pageSize),
      };
    } catch (error) {
      throw (
        error.response?.data || { message: "Erro ao listar autorizações" }
      );
    }
  },

  atualizarStatus: async (payload) => {
    try {
      const response = await api.put(
        "SolicitacaoDeAutorizacao/Status",
        payload
      );
      return response.data;
    } catch (error) {
      throw (
        error.response?.data || { message: "Erro ao atualizar status" }
      );
    }
  },

  // --- Documentos de Autorização ---
  uploadDocumentoAutorizacao: async (solicitacaoDeAutorizacaoId, arquivo) => {
    try {
      const formData = new FormData();
      formData.append("solicitacaoDeAutorizacaoId", solicitacaoDeAutorizacaoId);
      formData.append("arquivo", arquivo);
      const response = await api.post("DocumentoAutorizacao", formData);
      return response.data;
    } catch (error) {
      throw (
        error.response?.data || { message: "Erro ao enviar documento" }
      );
    }
  },

  listarDocumentosAutorizacao: async (solicitacaoDeAutorizacaoId) => {
    try {
      const response = await api.get(
        `DocumentoAutorizacao/solicitacao/${solicitacaoDeAutorizacaoId}`
      );
      return response.data?.data || [];
    } catch (error) {
      if (error.response?.status === 404) return [];
      throw (
        error.response?.data || { message: "Erro ao listar documentos" }
      );
    }
  },

  emitirAutorizacao: async (solicitacaoDeAutorizacaoId, arquivo, extras = {}) => {
    try {
      const formData = new FormData();
      formData.append("solicitacaoDeAutorizacaoId", solicitacaoDeAutorizacaoId);
      formData.append("arquivo", arquivo);
      const { condicionantes, observacoes, numeroInformado } = extras || {};
      if (condicionantes != null) formData.append("condicionantes", condicionantes);
      if (observacoes != null) formData.append("observacoes", observacoes);
      if (numeroInformado != null && String(numeroInformado).trim() !== "") {
        formData.append("numeroInformado", String(numeroInformado).trim());
      }
      const response = await api.post("AutorizacaoEmitida", formData);
      return response.data;
    } catch (error) {
      throw (
        error.response?.data || { message: "Erro ao emitir autorização" }
      );
    }
  },

  obterAutorizacaoEmitida: async (solicitacaoDeAutorizacaoId) => {
    try {
      const response = await api.get(
        `AutorizacaoEmitida/${solicitacaoDeAutorizacaoId}`
      );
      return response.data?.data || null;
    } catch (error) {
      if (error.response?.status === 404) return null;
      throw (
        error.response?.data || {
          message: "Erro ao obter autorização emitida",
        }
      );
    }
  },

  criarAutorizacaoIndependente: async (formData) => {
    try {
      const response = await api.post("AutorizacaoEmitida/Independente", formData);
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: "Erro ao criar autorização independente" };
    }
  },

  getAssinaturaPadrao: () =>
    api.get("AutorizacaoEmitida/AssinaturaPadrao", {
      responseType: "blob",
      validateStatus: (status) => status === 200 || status === 404,
    }),
};

export default autorizacoesService;
